import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 教研课程-筛选条件
   * @param {String}} business_type menu_id
   */
  getCourseFilterSet(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-getHighSetting/menu_high_setting`, params, config)
  },
  /**
   * 教研课程-筛选条件
   * @param {String}} course_name classify_id  organ_id
   */
  getResearchCourseFilter(params = {}, config) {
    return getFetch(
      `${baseHost}/common/api/32-excellent_course_filter/course_bk_portal`,
      params,
      config
    )
  },
  /**
   * 教研课程-列表
   * @param {String}} course_name classify_id  organ_id order_type
   */
  getResearchCourseList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-page_course/course_bk_portal`, params, config)
  }
}
